import Vue from 'vue';
import Router from 'vue-router';
import LoginMain from '@/components/Login/LoginMain.vue';
import LoginLogin from '@/components/Login/LoginLogin.vue';
import LoginForgot from '@/components/Login/LoginForgot.vue';
import HomeWrap from '@/components/HomeWrap.vue';
import Occasions from '@/components/Occasions.vue';
import CardCategories from '@/components/CardCategories.vue';
import Cards from '@/components/Cards.vue';
import Users from '@/components/Users.vue';
import GiftCards from '@/components/GiftCards.vue';
import Transactions from '@/components/Transactions.vue';
import SendGiftsTransactions from '@/components/SendGiftsTransactions.vue';
import UserTransactions from '@/components/UserTransactions.vue';
import GiftCardsTransactions from '@/components/GiftCardsTransactions.vue';

Vue.use(Router);
Vue.component('LoginMain', LoginMain);
Vue.component('LoginLogin', LoginLogin);
Vue.component('LoginForgot', LoginForgot);
Vue.component('HomeWrap', HomeWrap);

Vue.component('GiftCards', GiftCards);
Vue.component('Users', Users);
Vue.component('Occasions', Occasions);
Vue.component('CardCategories', CardCategories);
Vue.component('Cards', Cards);
Vue.component('Transactions', Transactions);
Vue.component('SendGiftsTransactions', SendGiftsTransactions);
Vue.component('UserTransactions', UserTransactions);
Vue.component('GiftCardsTransactions', GiftCardsTransactions);

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Login',
    //   component: LoginLogin,
    // },
    {
      path: '/',
      name: 'LoginMain',
      component: LoginMain,
      meta: {
        permissions: [],
      },
      children: [
        {
          name: 'Login',
          path: '/',
          component: LoginLogin,
        },
        {
          name: 'LoginLogin',
          path: '/login',
          component: LoginLogin,
        },
        {
          name: 'LoginReset',
          path: '/reset',
          component: LoginLogin,
        },
        {
          name: 'LoginForgot',
          path: '/forgot-password',
          component: LoginForgot,
        },
      ],
    },
    {
      path: '/login/:expired',
      component: LoginMain,
      name: 'LoginExpired',
      meta: {
        permissions: [],
      },
    },
    {
      path: '/home',
      name: 'HomeWrap',
      component: HomeWrap,
      meta: {
        permissions: [],
      },
      children: [
        {
          name: 'Users',
          path: '/users',
          component: Users,
        },
        {
          name: 'GiftCards',
          path: '/gift-cards/:user_id?',
          component: GiftCards,
        },
        {
          name: 'Occasions',
          path: '/occasions',
          component: Occasions,
        },
        {
          name: 'CardCategories',
          path: '/card-categories/:occasion_id?',
          component: CardCategories,
        },
        {
          name: 'Cards',
          path: '/cards/:card_category_id?',
          component: Cards,
        },
        {
          name: 'Transactions',
          path: '/transactions/',
          component: Transactions,
        },
        {
          name: 'SendGiftsTransactions',
          path: '/send-gifts-transactions/',
          component: SendGiftsTransactions,
        },
        {
          name: 'UserTransactions',
          path: '/transactions/users/:user_id',
          component: UserTransactions,
        },
        {
          name: 'GiftCardsTransactions',
          path: '/transactions/giftcard_transactions/:giftcard_code',
          component: GiftCardsTransactions,
        },
      ],
    },
  ],
});
